// extracted by mini-css-extract-plugin
module.exports = {"container":"yEd6uN8","wrapper":"Ho4PHGm","slideUp":"_2hAzXct","flag":"_3paRtY8","text":"_3zgRKFs","redirectLink":"_3OLsPHG","close":"_19aAF1K","closeButton":"_1MzGrY_"};